export default __webpack_public_path__ + "static/media/houimg17.780db018.webp";